import { createStore } from 'vuex';

import contextStore from './modules/contextStore';
import applicationPayingOrgsStore from './modules/application/payingOrgsStore';
import applicationRateConfigurationsStore from './modules/application/rateConfigurationsStore';
import currentApplicationStore from './modules/application/currentApplicationStore';
import applicationSalaryFractionsStore from './modules/application/salaryFractionsStore';
import orgConfigurationStore from './modules/settings/orgConfigurationStore';
import rateSummariesStore from './modules/settings/rateSummariesStore';
import currentTaxRatePeriodStore from './modules/application/currentTaxRatePeriodStore';
import errorStore from './modules/errorStore';
import helpBarStore from './modules/helpBarStore';
import currentOrgsStore from './modules/currentOrgsStore';
import functionTypes from './modules/functionTypesStore';
import infoMessagesStore from './modules/infoMessagesStore';
import buypassOrgsStore from "./modules/buypassOrgsStore";
import snacksStore from './modules/snacksStore';
import utilsRestStore from './modules/utilsRestStore';

const debug = process.env.NODE_ENV !== 'production';

export default createStore({
    modules: {
        functionTypes: functionTypes,
        contextStore: contextStore,
        currentTaxRatePeriodStore: currentTaxRatePeriodStore,
        errorStore: errorStore,
        helpBarStore: helpBarStore,
        currentOrgsStore: currentOrgsStore,
        infoMessagesStore: infoMessagesStore,
        buypassOrgsStore: buypassOrgsStore,
        utilsRestStore: utilsRestStore,
        snacksStore: snacksStore,
        application: {
            namespaced: true,
            modules: {
                currentApplicationStore,
                'payingOrgsStore': applicationPayingOrgsStore,
                'rateConfigurationsStore': applicationRateConfigurationsStore,
                'salaryFractionsStore': applicationSalaryFractionsStore
            }
        },
        settings: {
            namespaced: true,
            modules: {
                orgConfigurationStore,
                rateSummariesStore
            }
        }
    },
    strict: debug
});
